module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_0.4c82f967.png";